export enum TaskAlignmentType {
  TODO = 'TODO',
  GOAL = 'GOAL',
  ONE_TO_ONE = 'ONE_TO_ONE',
  MILESTONE = 'MILESTONE'
}